import { useContext } from 'react';
import {
  Modal,
  Box,
  IconButton,
  Typography
} from "@mui/material";
import { 
  Close as CloseIcon, 
  InfoOutlined as InfoOutlinedIcon, 
  Videocam
} from "@mui/icons-material";
import { QrScan } from "../../QrScan";
import { BoxModal, CustomButtonV2 } from "../../../pages/styles";
import { ColorsContext } from "../../../Context/ColorsContext";
import { BodyContainer, HeaderContainer, InformationText, TitleModal } from './styles';
import { useTranslation } from 'react-i18next';

export const QrScannerModal = ({
  open,
  onClose,
  title,
  startScanning,
  onStartScanning,
  onScan,
  onError
}) => {
  const { colors } = useContext(ColorsContext);
  const { t } = useTranslation();
  
  const displayTitle = title || t('qrScanner.title');

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="qr-scan-modal-title"
    >
      <BoxModal
        sx={{
          width: "90%",
          maxWidth: "500px",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          maxHeight: "90vh",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: `1px solid ${colors.gray}`,
          }}
        >
          <HeaderContainer>
            <TitleModal id="qr-scan-modal-title">
              {displayTitle}
            </TitleModal>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </HeaderContainer>
        </Box>

        <BodyContainer style={{ minHeight: "400px", display: "flex", flexDirection: "column" }}>
          
          <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
            <InformationText>
              {t('qrScanner.pointCamera')}
            </InformationText>
          </div>

          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
            <QrScan
              startScanning={startScanning}
              onScan={onScan}
              onError={onError}
              onStartScanning={onStartScanning}
            />
          </Box>

          <Box sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            gap: 0.5, 
            mt: 1, 
            mb: 1 
          }}>
            <InfoOutlinedIcon sx={{ color: "#92a0b2", fontSize: "16px" }} />
            <Typography sx={{ color: "#92a0b2", fontSize: "11px", textAlign: "center" }}>
              {t('qrScanner.autoScan')}
            </Typography>
          </Box>

          <Box sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            mt: 1,
            pointerEvents: 'auto',
            minHeight: "40px"
          }}>
            <CustomButtonV2
              variant="contained"
              onClick={onStartScanning}
              startIcon={<Videocam />}
              sx={{
                width: "30%",
              }}
              disabled={startScanning}
            >
              {t('qrScanner.openCamera')}
            </CustomButtonV2>

            <CustomButtonV2
              btnType="close"
              sx={{
                width: "30%",
              }}
              onClick={onClose}
              disabled={startScanning}
            >
              {t('qrScanner.cancel')}
            </CustomButtonV2>
          </Box>
        </BodyContainer>
      </BoxModal>
    </Modal>
  );
};
